// src/authConfig.js
import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: 'd0377a16-1ea2-42a7-90c3-863e68361328',
        authority: 'https://login.microsoftonline.com/consumers',
        redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/auth` : 'http://localhost:3000/auth',
        postLogoutRedirectUri: typeof window !== 'undefined' ? `${window.location.origin}/auth` : 'http://localhost:3000/auth',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error: console.error('[MSAL Error]', message); return;
                    case LogLevel.Info: console.info('[MSAL Info]', message); return;
                    case LogLevel.Verbose: console.debug('[MSAL Debug]', message); return;
                    case LogLevel.Warning: console.warn('[MSAL Warning]', message); return;
                }
            },
            logLevel: LogLevel.Verbose,
        },
        allowNativeBroker: false,
    },
};

export const loginRequest = {
    scopes: ['User.Read', 'openid', 'profile', 'email'],
    prompt: 'select_account',
};

export const silentRequest = {
    scopes: ['User.Read', 'openid', 'profile'],
};

export const getCurrentAccount = (msalInstance) => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
        return null;
    }
    const activeAccount = msalInstance.getActiveAccount();
    if (activeAccount) {
        return activeAccount;
    }
    msalInstance.setActiveAccount(accounts[0]);
    return accounts[0];
};

export const getAccessToken = async (msalInstance, scopes = loginRequest.scopes) => {
    const account = getCurrentAccount(msalInstance);
    if (!account) {
        throw new Error('No active account');
    }

    const request = {
        scopes,
        account,
    };

    try {
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (silentError) {
        console.warn('静默获取token失败，尝试交互式获取:', silentError);
        try {
            const response = await msalInstance.acquireTokenRedirect(request);
            return response.accessToken;
        } catch (redirectError) {
            console.error('获取token失败:', redirectError);
            throw redirectError;
        }
    }
};

export const isAuthenticated = (msalInstance) => {
    return msalInstance.getAllAccounts().length > 0;
};

export const logout = (msalInstance) => {
    const logoutRequest = {
        account: msalInstance.getActiveAccount(),
        postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
    };
    
    msalInstance.logoutRedirect(logoutRequest).catch((error) => {
        console.error('登出失败:', error);
    });
};

export default msalConfig;